import { css, type SerializedStyles } from '@emotion/react'
import { type Theme } from '@mui/material/styles'
import { rem } from 'polished'

export const buttonsGroup = (theme: Theme): SerializedStyles =>
  css({
    alignItems: 'center',
    bottom: 0,
    display: 'flex',
    flexDirection: 'row-reverse',
    flexWrap: 'wrap',
    justifyContent: 'center',
    // TODO: gap: theme.spacing(2) et padding: `${theme.spacing(4)} 0`
    padding: theme.spacing(3, '0'),
  })

export const inACard = (theme: Theme): SerializedStyles =>
  css({
    margin: `-${theme.spacing(1)}`, // TODO: à retirer quand gap sera mis sur buttonGroup
    padding: 0, // According to figma rules https://www.figma.com/design/5XNDzMhQRjuwlf7leEc9wb/Composants-DS-SIBR?node-id=127525-301076&t=sOE2LVJ5OTOse9qg-4
  })

export const fullWidth = css({
  width: '100%',
})

export const customWidth = (width: number): SerializedStyles =>
  css({
    width: rem(width),
  })

export const buttonInGroup = (theme: Theme): SerializedStyles =>
  css({
    // TODO: retirer avec gap
    margin: theme.spacing(1),
  })

export const bottomActions = (theme: Theme): SerializedStyles =>
  css({
    padding: theme.spacing(2, 1.5),
  })
